import { useMemo } from "react";
import { Outlet } from "react-router-dom";
import "twin.macro";
import { usePermissions } from "./utils/auth/PermissionsContext";
import { FourOhOne } from "./routes/error/FourOhOne";
import { HasChildren } from "./types/shared";
import { Permission } from "./utils/auth/Permission";

interface Props extends HasChildren {
  permission: Permission;
}

const PermissionProtectedRoute = ({ permission, children }: Props) => {
  const { hasPermission } = usePermissions();

  const isAuthorized = useMemo(
    () => hasPermission(permission),
    [permission, hasPermission]
  );

  if (!isAuthorized) {
    return <FourOhOne />;
  }

  return children || <Outlet />;
};

export default PermissionProtectedRoute;
